import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Navigate } from '@ngxs/router-plugin';
import { select, Store } from '@ngxs/store';
import { TeamFeature } from '@shared/models/features.model';
import { UpdateTeamFeature } from '@shared/states/account.actions';
import { AccountState } from '@shared/states/account.state';
import { brandedUrl } from '@shared/utilities/branding.utilities';

@Component({
  selector: 'zef-beta-button',
  templateUrl: './beta-button.component.html',
  styleUrls: ['./beta-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BetaButton {
  private store = inject(Store);

  readonly brandedUrl = brandedUrl;
  readonly isTeamAdmin = select(AccountState.isTeamAdmin);

  readonly isEnabled = select(AccountState.isFeatureEnabled());

  enableExperimental() {
    this.store.dispatch([
      new UpdateTeamFeature(TeamFeature.ENABLE_EXPERIMENTAL, true),
      new UpdateTeamFeature(TeamFeature.ALL_FEATURES, true),
      new Navigate(['/settings/org']),
    ]);
  }
}
